/* quickshop/ajax
   ========================================================================== */
import updateMobileCartCounter from '../cart/counter';
import handleError from '../cart/handleError';
import setCartVisibility from '../cart/setCartVisibility';
import retrieveFormData from '../cart/retrieveFormData';
import showLoader from '../loader';
export default function ajaxAddProduct(quickshopComponent) {
    const buttons = quickshopComponent.querySelectorAll('[data-quickshop-add-product-btn]');
    if (buttons.length > 0) {
        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const form = button.closest('[data-quickshop-add-product-form]');
                button.disabled = true;
                const hideLoader = showLoader(button, { hideContent: true });
                fetch(form.action, {
                    method: 'POST',
                    body: retrieveFormData(form),
                })
                    .then((response) => {
                    if (response.redirected) {
                        window.location.href = response.url;
                    }
                    return response.text();
                })
                    .then((body) => {
                    // @ts-ignore
                    if (quickshopComponent.dialog) {
                        // @ts-ignore
                        quickshopComponent.dialog.hide();
                    }
                    const lists = document.querySelectorAll('li.js-dynamic-menu');
                    lists.forEach((list) => {
                        list.outerHTML = body;
                    });
                    const cart = document.querySelector('.js-cart');
                    if ('error' in cart.dataset) {
                        handleError(cart);
                        return;
                    }
                    setCartVisibility(cart);
                    updateMobileCartCounter();
                })
                    .finally(() => {
                    hideLoader();
                    button.disabled = false;
                });
            });
        });
    }
}
